(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var customerId = root.dataset.customerId || '';
    var apiBase = (root.dataset.apiBase || 'https://tl.adshopify.com').replace(/\/$/, '');
    var loginUrl = root.dataset.loginUrl || '/account/login';
    var storefrontLoginUrl = root.dataset.storefrontLoginUrl || '';
    var registerUrl = root.dataset.registerUrl || '/account/register';
    var isLoggedIn = Boolean(customerId);
    var SOURCE_STORAGE_KEY = 'activity_prize_source';
    var sectionSource = (root.dataset.campaignSource || '').trim();
    var prizeValidThrough = (root.dataset.prizeValidThrough || 'Dec. 31, 2026').trim();

    function captureTrafficSource() {
      try {
        var params = new URLSearchParams(window.location.search);
        var fromUrl = (
          params.get('utm_source') ||
          params.get('activity_prize_source') ||
          params.get('source') ||
          ''
        ).trim();
        if (fromUrl) {
          sessionStorage.setItem(SOURCE_STORAGE_KEY, fromUrl);
          return fromUrl;
        }
        if (sectionSource) {
          return sectionSource;
        }
        var stored = sessionStorage.getItem(SOURCE_STORAGE_KEY);
        return stored ? String(stored).trim() : '';
      } catch (e) {
        return sectionSource || '';
      }
    }

    var trafficSource = captureTrafficSource();

    var prizeMap = {};
    try {
      var mapEl = root.querySelector('[data-prize-map]');
      prizeMap = JSON.parse((mapEl && mapEl.textContent) || '{}');
    } catch (e) {
      prizeMap = {};
    }

    var state = {
      chances: isLoggedIn ? 0 : 1,
      prizeCount: 0,
      drawing: false,
      eventActive: true,
      selectedIndex: null,
      history: []
    };

    var chancesEl = root.querySelector('[data-chances]');
    var hintEl = root.querySelector('[data-click-hint]');
    var pickButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pick-index]')).slice(0, 6);
    pickButtons.forEach(function (btn, idx) {
      btn.setAttribute('data-pick-index', String(idx));
    });
    var revealModal = root.querySelector('[data-reveal-modal]');
    var revealCard = root.querySelector('[data-reveal-card]');
    var revealMessage = root.querySelector('[data-reveal-message]');
    var prizesModal = root.querySelector('[data-prizes-modal]');
    var prizeListEl = root.querySelector('[data-prize-list]');
    var loginModal = root.querySelector('[data-login-modal]');

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function prizeImage(key) {
      return (prizeMap[key] && prizeMap[key].image) || '';
    }

    function getReturnPath() {
      return window.location.pathname + window.location.search + window.location.hash;
    }

    function buildAuthUrl(base) {
      var encoded = encodeURIComponent(getReturnPath());
      if (base.indexOf('customer_authentication') >= 0 || storefrontLoginUrl) {
        return (storefrontLoginUrl || '/customer_authentication/login') + '?return_to=' + encoded;
      }
      var sep = base.indexOf('?') >= 0 ? '&' : '?';
      return base + sep + 'return_url=' + encoded;
    }

    function showModal(el) {
      if (!el) return;
      el.hidden = false;
      document.body.classList.add('activity-prize-draw-modal-open');
    }

    function hideModal(el) {
      if (!el) return;
      el.hidden = true;
      if (
        (!revealModal || revealModal.hidden) &&
        (!prizesModal || prizesModal.hidden) &&
        (!loginModal || loginModal.hidden)
      ) {
        document.body.classList.remove('activity-prize-draw-modal-open');
      }
    }

    function showLogin() {
      var loginLink = root.querySelector('[data-login-link]');
      var registerLink = root.querySelector('[data-register-link]');
      if (loginLink) loginLink.href = buildAuthUrl(loginUrl);
      if (registerLink) registerLink.href = buildAuthUrl(registerUrl);
      showModal(loginModal);
    }

    function api(path, options) {
      return fetch(apiBase + path, options || {}).then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) {
            var detail = body && body.detail;
            throw new Error(typeof detail === 'string' ? detail : 'Request failed');
          }
          return body;
        });
      });
    }

    function syncPumpkinLit() {
      pickButtons.forEach(function (btn, idx) {
        var lit = state.selectedIndex === idx;
        var onImg = btn.querySelector('.activity-prize-draw__pick-on');
        if (onImg) onImg.classList.toggle('is-visible', lit);
      });
    }

    function applySelectedFromHistory(items) {
      if (!items || !items.length) return;
      var row = items[0];
      if (row.pick_index !== null && row.pick_index !== undefined && row.pick_index !== '') {
        var picked = Number(row.pick_index);
        if (!isNaN(picked) && picked >= 0 && picked < pickButtons.length) {
          state.selectedIndex = picked;
        }
      }
    }

    function updateUI() {
      var alreadyPlayed = state.prizeCount > 0 || state.selectedIndex !== null;
      var canPick =
        isLoggedIn && state.eventActive && state.chances > 0 && !state.drawing && !alreadyPlayed;
      if (chancesEl) {
        chancesEl.textContent = String(isLoggedIn ? (alreadyPlayed ? 0 : state.chances) : 1);
      }
      if (hintEl) hintEl.hidden = !canPick;
      root.classList.toggle('is-picked', state.selectedIndex !== null);

      pickButtons.forEach(function (btn, idx) {
        var exhausted =
          isLoggedIn && (!state.eventActive || state.chances <= 0 || alreadyPlayed);
        btn.disabled = state.drawing || exhausted;
        btn.classList.toggle('is-dimmed', state.selectedIndex !== null && state.selectedIndex !== idx);
        btn.classList.toggle('is-selected', state.selectedIndex === idx);
      });
      syncPumpkinLit();
    }

    function loadStatus() {
      if (!isLoggedIn) {
        updateUI();
        return Promise.resolve();
      }
      return api('/api/activity-prize/status?user_id=' + encodeURIComponent(customerId))
        .then(function (data) {
          state.chances = Number(data.available_chances) || 0;
          state.eventActive = data.event_active !== false;
          state.prizeCount = Number(data.prize_count) || 0;
          updateUI();
        })
        .catch(function (err) {
          console.warn('[activity-prize]', err);
          updateUI();
        });
    }

    function loadHistory() {
      if (!isLoggedIn) {
        renderHistory([]);
        return Promise.resolve();
      }
      return api('/api/activity-prize/history?user_id=' + encodeURIComponent(customerId))
        .then(function (data) {
          state.history = data.history || [];
          state.prizeCount = state.history.length;
          applySelectedFromHistory(state.history);
          renderHistory(state.history);
          updateUI();
        })
        .catch(function () {
          renderHistory([]);
        });
    }

    function formatPrizeDetailLine(prizeKey, prizeDetail) {
      var detail = prizeDetail ? String(prizeDetail).trim() : '';
      if (!detail) return '';
      if (prizeKey.indexOf('gift_card') === 0 && detail.indexOf('Code') !== 0) {
        return 'Code: ' + detail;
      }
      if (prizeKey === 'free_shipping' && detail.indexOf('Use code') !== 0) {
        return 'Use code: ' + detail;
      }
      return detail;
    }

    function buildPrizeCardHtml(prizeName, prizeKey, prizeDetail) {
      var img = prizeImage(prizeKey);
      var detailLine = formatPrizeDetailLine(prizeKey, prizeDetail);
      return (
        '<div class="activity-prize-draw__prize-card">' +
        (img
          ? '<img src="' + escapeHtml(img) + '" alt="" width="72" height="72">'
          : '<div class="activity-prize-draw__prize-card-thumb" aria-hidden="true"></div>') +
        '<div class="activity-prize-draw__prize-card-body">' +
        '<strong>' +
        escapeHtml(prizeName) +
        '</strong>' +
        '<span class="activity-prize-draw__prize-valid">Valid through ' +
        escapeHtml(prizeValidThrough) +
        '</span>' +
        (detailLine
          ? '<span class="activity-prize-draw__prize-code">' + escapeHtml(detailLine) + '</span>'
          : '') +
        '</div></div>'
      );
    }

    function renderHistory(items) {
      if (!prizeListEl) return;
      if (!items.length) {
        prizeListEl.innerHTML =
          '<p class="activity-prize-draw__empty">Pick your favorite pumpkin and get your reward! Everyone wins!</p>';
        return;
      }
      prizeListEl.innerHTML = items
        .map(function (item) {
          return buildPrizeCardHtml(item.prize_name, item.prize_key, item.prize_detail);
        })
        .join('');
    }

    function showReveal(data) {
      if (revealCard) {
        revealCard.innerHTML = buildPrizeCardHtml(data.prize_name, data.prize_key, data.prize_detail);
      }
      if (revealMessage) {
        var note = data.message || '';
        if (note && data.prize_detail && note.indexOf(String(data.prize_detail)) >= 0) {
          note = '';
        }
        revealMessage.textContent = note;
        revealMessage.hidden = !note;
      }
      showModal(revealModal);
    }

    function onPick(index) {
      if (state.drawing || state.selectedIndex !== null) return;
      if (!isLoggedIn) {
        showLogin();
        return;
      }
      if (!state.eventActive || state.chances < 1) return;

      state.selectedIndex = index;
      state.drawing = true;
      updateUI();

      var btn = pickButtons[index];

      // pick_index is cosmetic only; API draws randomly from the 5-prize pool (20% each)
      var drawUrl =
        '/api/activity-prize/draw?user_id=' +
        encodeURIComponent(customerId) +
        '&pick_index=' +
        index;
      if (trafficSource) {
        drawUrl += '&source=' + encodeURIComponent(trafficSource);
      }
      api(drawUrl, {
        method: 'POST'
      })
        .then(function (data) {
          state.chances = Number(data.remaining_chances) || 0;
          if (data.pick_index !== null && data.pick_index !== undefined) {
            state.selectedIndex = Number(data.pick_index);
          }
          state.prizeCount += 1;
          state.drawing = false;
          updateUI();
          setTimeout(function () {
            showReveal(data);
            loadHistory();
          }, 700);
        })
        .catch(function (err) {
          state.drawing = false;
          if (err.message && err.message.indexOf('already used') >= 0) {
            state.chances = 0;
            loadHistory();
          } else {
            state.selectedIndex = null;
          }
          updateUI();
          alert(err.message || 'Draw failed. Please try again.');
        });
    }

    pickButtons.forEach(function (btn) {
      var index = parseInt(btn.getAttribute('data-pick-index'), 10);
      btn.addEventListener('click', function () {
        onPick(index);
      });
      btn.addEventListener('mouseenter', function () {
        if (btn.disabled || state.selectedIndex !== null) return;
        btn.classList.add('is-hovered');
        var onImg = btn.querySelector('.activity-prize-draw__pick-on');
        if (onImg) onImg.classList.add('is-visible');
      });
      btn.addEventListener('mouseleave', function () {
        btn.classList.remove('is-hovered');
        if (state.selectedIndex !== index) {
          var onImg = btn.querySelector('.activity-prize-draw__pick-on');
          if (onImg) onImg.classList.remove('is-visible');
        }
      });
    });

    root.querySelectorAll('[data-open-prizes]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (!isLoggedIn) {
          showLogin();
          return;
        }
        loadHistory().then(function () {
          showModal(prizesModal);
        });
      });
    });

    root.querySelectorAll('[data-close-reveal]').forEach(function (el) {
      el.addEventListener('click', function () {
        hideModal(revealModal);
      });
    });
    root.querySelectorAll('[data-close-prizes]').forEach(function (el) {
      el.addEventListener('click', function () {
        hideModal(prizesModal);
      });
    });
    root.querySelectorAll('[data-close-login]').forEach(function (el) {
      el.addEventListener('click', function () {
        hideModal(loginModal);
      });
    });

    loadStatus().then(loadHistory);
  }

  function boot() {
    document.querySelectorAll('[data-activity-prize-draw]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
